const getThreadRunStateValue = ({ threadContentValue, threadMetaValue }) => {
  return String(threadContentValue?.runState?.state || threadMetaValue?.runState?.state || 'idle')
    .trim()
    .toLowerCase();
};

export default getThreadRunStateValue;
